// Branding Constants for SynapSee Studio
export const BRANDING = {
    PRODUCT_NAME: "SynapSee Studio",
    // FEATURE_ATTENTION_INSIGHT removed to force specific usage
    FEATURE_IMAGE_INSIGHT: "Image Insight",
    FEATURE_VIDEO_INSIGHT: "Video Insight",
    FEATURE_NEUROGEN_AI: "NeuroGen AI",
    // UI Labels
    LABEL_ROOT_FOLDER: "SynapSee Studio",
    LABEL_OPTIMIZER_BUTTON: "Gerar NeuroGen AI",
    LABEL_INSIGHTS_PANEL: "INSIGHTS", 
    LABEL_PROTOTYPE: "NeuroGen AI",
    // Entities
    LABEL_ENTITY_SINGULAR: "Criativo",
    LABEL_ENTITY_PLURAL: "Criativos",
};

// Nome do briefing de uma pasta. DERIVA da pasta porque o valor e user-visible —
// vira o chip de contexto no upload (BulkUploadConfirmation/ConfirmationDialog),
// entao um literal pt-BR vazaria numa UI pt/en/es e duas pastas encadeadas
// renderizariam dois chips identicos. Fallback igual ao das outras telas: pasta
// sem nome e a raiz.
export const folderBriefingName = (folderName) => folderName || BRANDING.LABEL_ROOT_FOLDER;
